import type { TransferChannel } from '@app/core/models';

export const CHANNEL_LABELS: Record<TransferChannel, string> = {
  SEPA: 'SEPA Transfer',
  SWIFT: 'SWIFT Transfer',
  ON_CHAIN: 'Crypto Transfer',
  FX_CONVERSION: 'Conversion',
};

export function isFiatChannel(channel: TransferChannel): boolean {
  return channel === 'SEPA' || channel === 'SWIFT';
}

export function isCryptoChannel(channel: TransferChannel): boolean {
  return channel === 'ON_CHAIN';
}

export function isConversionChannel(channel: TransferChannel): boolean {
  return channel === 'FX_CONVERSION';
}

export function formatTransferDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatTransferAmount(amount: string, currency: string): string {
  const num = parseFloat(amount);
  if (['EUR', 'USD', 'GBP', 'CHF', 'AED'].includes(currency)) {
    return `${currency} ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return `${num} ${currency}`;
}

export function truncateId(id: string): string {
  return id.slice(0, 8);
}
